import React from 'react';
import useReactRouter from 'use-react-router';
import { RoutePath } from 'configs/routes';
import './bizon-steps-styles.scss';

/**
 * Componente criado para atender ao caso do bizon.
 * Foi necessário em um primeiro momento manter a lógica abaixo uma vez que o último
 * step não segue o padrão dos outros no layout do status atual.
 */

type Step = [string, 'previous' | 'current' | 'next'];

const BizonSteps: React.FC = (): JSX.Element => {
    const { match } = useReactRouter();

    let steps: Step[] = [];

    if (match.path === ('/:loanApplicationId/identificacao' as RoutePath) ||
        match.path === ('/:loanApplicationId/socio/identificacao/status' as RoutePath)) {
        steps = [
            ['identificação', 'current'],
            ['documentos', 'next'],
            ['aprovação', 'next'],
        ];
    }

    if (match.path === '/:loanApplicationId/documentacao' as RoutePath) {
        steps = [
            ['identificação', 'previous'],
            ['documentos', 'current'],
            ['aprovação', 'next'],
        ];
    }

    if (match.path === '/:loanApplicationId/aprovado' as RoutePath) {
        steps = [
            ['identificação', 'previous'],
            ['documentos', 'previous'],
            ['aprovação', 'previous'],
        ];
    }

    const [identity, documents, approval] = steps;

    return (
        <div className="c-step">
            <div className={`c-step__item c-step__item--${identity[1]}`}>
                <span>{identity[0]}</span>
            </div>

            <div className="c-step__line" />

            <div className={`c-step__item c-step__item--${documents[1]}`}>
                <span>{documents[0]}</span>
            </div>

            <div className="c-step__line" />

            <div className={`c-step__item c-step__item--${approval[1]}`}>
                <span>{approval[0]}</span>
            </div>
        </div>
    );
}

export default BizonSteps;
